import { render, staticRenderFns } from "./list.vue?vue&type=template&id=b71fa6a4&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=b71fa6a4&prod&lang=sass&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=b71fa6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71fa6a4",
  null
  
)

export default component.exports